<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { axiosInstance } from "./http_client";
import pkg from "../package.json";

export default {
    computed: {
        ...mapGetters(['currentUser'])
    },
    methods: {
        ...mapActions(['getEnrollments', 'getRegistrations'])
    },
    mounted() {
        console.log('App mounted');

        axiosInstance.interceptors.response.use(
            (response) => {
                const latestAppVersion = response.headers['latest-app-version'];
                this.axiosTest = response.config.url;
                if (latestAppVersion && latestAppVersion !== pkg.version) {
                    console.warn(`The app is out of date.  App version: ${pkg.version}, Latest version: ${latestAppVersion}`);
                }
                return response;
            },
            (error) => {
                return Promise.reject(error);
            }
        );

        // if (!localStorage.getItem('token')) this.$router.push('/');

        if (this.currentUser) {
            this.getEnrollments();
            this.getRegistrations();
        }
    }
};
</script>

<style lang="scss">
// Animate
$animationDuration: 0.5s; // specify animation duration. Default value: 1s
@import "~vue2-animate/src/sass/vue2-animate.scss";

// BUEFY
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

$body-size: 16px;

// Tweaks to animation and fix to slide animation on collapse
$speed-slow: 600ms !default;
$speed-slower: 800ms !default;

.slide-enter-to,
.slide-leave {
    max-height: 999px !important;
    overflow: hidden;
}

// Set your colors
$primary: #336699;
$primary-light: findLightColor($primary);
$primary-dark: findDarkColor($primary);
$primary-invert: findColorInvert($primary);
$twitter: #4099FF;
$twitter-invert: findColorInvert($twitter);

$danger: #9b0d0d;
$danger-light: findLightColor($danger);
$danger-dark: findDarkColor($danger);

$warning: #e28b05;
$warning-light: findLightColor($warning);
$warning-dark: findDarkColor($warning);

// Lists and maps
$custom-colors: null !default;
$custom-shades: null !default;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: mergeColorMaps(("white": ($white,
                $black,
            ),
            "black": ($black,
                $white,
            ),
            "light": ($light,
                $light-invert,
            ),
            "dark": ($dark,
                $dark-invert,
            ),
            "primary": ($primary,
                $primary-invert,
                $primary-light,
                $primary-dark,
            ),
            "link": ($link,
                $link-invert,
                $link-light,
                $link-dark,
            ),
            "info": ($info,
                $info-invert,
                $info-light,
                $info-dark,
            ),
            "success": ($success,
                $success-invert,
                $success-light,
                $success-dark,
            ),
            "warning": ($warning,
                $warning-invert,
                $warning-light,
                $warning-dark,
            ),
            "danger": ($danger,
                $danger-invert,
                $danger-light,
                $danger-dark,
            ),
        ),
        $custom-colors );

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Messages
$message-body-padding: .8em 1.7em;

// Modals / Dropdowns
$modal-z: 500;
$dropdown-content-z: 500;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

html,
body {
    overflow: hidden;
    padding: 0 !important;
    margin: 0 !important;
    background: white;
}

body {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow-x: hidden;
    overflow-y: auto;
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    margin: 0;
}

.notification .notification-message {
    .title {
        font-size: 1.3rem;
        margin-bottom: 1rem;
    }

    .message {
        background-color: white !important;
    }
}

.timeline {
    list-style: none !important;
}

.dropdown .background {
    z-index: 499;
}

.dropdown.is-mobile-modal>.dropdown-menu {
    z-index: 500 !important;
}
</style>
